import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchReviews } from "../../redux/slices/reviews";

import Title from "../components/title";
import Empty from "./components/empty";

import ReviewsCarousel from "./reviews-carousel";
import { ReviewsPart } from "./reviews-part";
import { Stats } from "./stats";

const Reviews = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // Отзывы, привязанные к туру, живут на странице этого тура. Здесь — общие:
  // иначе один и тот же скриншот встречал бы человека дважды.
  const reviews = useSelector((state) =>
    state.reviews.reviews.items.filter((review) => !review.activityId)
  );

  useEffect(() => {
    dispatch(fetchReviews());
  }, [dispatch]);

  // Отзывы-скриншоты (весь отзыв — картинка) в колонку не ставим: их два
  // десятка, и страница превращалась в бесконечную ленту фотографий, по
  // которой надо скроллить минуту. Картинки уходят в карусель, а в колонке
  // остаются написанные словами — их читают, а не листают.
  const written = reviews.filter((review) => review.comment?.trim());
  const hasPhotos = reviews.some((review) => (review.photos || []).length > 0);

  return (
    <div
      id="reviews"
      className="max-w-[1526px] w-full mx-auto px-4 flex flex-col gap-y-12 sm:gap-y-14 my-4"
    >
      <Title name={`${t("reviews.title")}`} />
      <div className="w-full max-w-7xl mx-auto sm:px-6 lg:px-12 lg:grid lg:grid-cols-12 lg:gap-x-8">
        <Stats reviews={reviews} />

        {reviews && reviews.length > 0 ? (
          <ReviewsPart reviews={written} total={reviews.length} />
        ) : (
          <Empty
            text={t("reviews.emptyTitle")}
            subText={t("reviews.emptySubText")}
          />
        )}
      </div>

      {/* Отзывы наши клиенты присылают в WhatsApp, а не пишут в форме, —
          поэтому большая их часть здесь именно карусель картинок. */}
      {hasPhotos && <ReviewsCarousel fetchOnMount={false} />}
    </div>
  );
};

export default Reviews;
